import { create } from './create';
import { deleteEndpoint } from './delete';
import { get } from './get';
import { list } from './list';
import { patch } from './patch';
import { test } from './test';
import { testExisting } from './testExisting';

export { type CreateIntegrationCredentialPayload } from './create';
export { type IntegrationCredentialsListQuery } from './list';
export { type PatchIntegrationCredentialPayload } from './patch';
export { type TestIntegrationCredentialPayload } from './test';
export { type TestExistingIntegrationCredentialPayload } from './testExisting';

export const integrationCredentials = {
  list,
  get,
  create,
  patch,
  delete: deleteEndpoint,
  test,
  testExisting,
};
